import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.3/js/sparta-events-utility";







const utilName = 'focus-trap-utility';
const fontStyle = 'cnx-regular';

const EVENTS = {
  FOCUSOUT: `FOCUSOUT.${utilName}`,
};









const createBoundaryElement = (htmlContent, className, ariaHidden) => {
  const bound = document.createElement('div');
  bound.innerHTML = htmlContent;
  bound.classList.add(className);
  bound.classList.add('ada-hidden');
  bound.classList.add(fontStyle);
  bound.setAttribute('aria-hidden', !!ariaHidden);
  bound.setAttribute('tabindex', '-1');
  return bound;
};




const englishBeginText = 'Beginning of Layer';
const spanishBeginText = 'Inicio de la ventana';
const englishEndText = 'End of Layer';
const spanishEndText = 'Fin de la ventana';


const isSpanish = sparta.language === 'es'; 
const defaultBeginText = isSpanish ? spanishBeginText : englishBeginText;
const defaultEndText = isSpanish ? spanishEndText : englishEndText;






class FocusTrap {






  constructor(args = {}) {

    this.layerBeginText = args.layerBeginText || defaultBeginText;
    this.layerEndText = args.layerEndText || defaultEndText;
    this.hideBoundText = !!args.hideBoundText || false;

    this.setContainer(args.container, args.containerID);
    this.setBounds();

    this.previousFocus = null;

    this.focusOut = this.focusoutCallback.bind(this);
    this.focusIn = this.focusinCallback.bind(this);
  }








  setBounds(layerBeginText = this.layerBeginText, layerEndText = this.layerEndText) {
    this.topBound = this.addClickHandler(createBoundaryElement(layerBeginText, 'focus-boundary-top', this.hideBoundText));
    this.bottomBound = this.addClickHandler(createBoundaryElement(layerEndText, 'focus-boundary-bottom', this.hideBoundText));
    this.bounceBound = createBoundaryElement('', 'focus-boundary-bounce', true);
  }








  setClasslist(containerClass = utilName, container = this.container) {
    if (container && container.classList) {
      container.classList.add(containerClass);
    }
    return this;
  }








  setContainer(container, containerID) {
    this.removeTrap();
    this.container = container || document.getElementById(containerID);
    this.setClasslist();
    return this;
  }






  wasBounced() {
    return this.previousFocus === this.bottomBound || this.previousFocus === this.topBound;
  }







  getFocusoutTarget(event) {
    return event.target === this.topBound ? this.bottomBound : this.topBound;
  }







  focusoutCallback(event) {
    if (!this.wasBounced()) {
      const nextElem = event.relatedTarget || document.activeElement;
      if (!this.container.contains(nextElem)) {
        const targetElem = this.getFocusoutTarget(event);
        targetElem.focus();
        this.previousFocus = nextElem;
        spartaEventsUtility.pub(EVENTS.FOCUSOUT, {
          event,
        });
      }
    }
    return this;
  }






  focusinCallback() {
    this.topBound.focus();
    return this;
  }





  modalClickEvent(object) {
    let container = object.container;
    let topBound = object.topBound;
    let bottomBound = object.bottomBound;
    object.container.addEventListener('keydown', function (event) {
      let thisKeyCode = event.charCode || event.keyCode;
      let trigger = event.target || event.srcElement;


      let tabbables = container.querySelectorAll('button, [href], input, select, textarea');
      let tabbablesFirst = tabbables[0];
      let tabbablesLast = tabbables[tabbables.length - 1];


      if (event.shiftKey && event.key === 'Tab')  {

        if (trigger === bottomBound) {
          event.preventDefault();
          tabbablesLast.focus();
        }

        else if (trigger === topBound) {
          event.preventDefault();
          bottomBound.focus();
        }
      }

      else if (thisKeyCode === 9) {

        if (trigger === tabbablesLast) {
          event.preventDefault();
          bottomBound.focus();
        }

        else if (trigger === bottomBound) {
          event.preventDefault();
          topBound.focus();
        }
      }
    })
  }







  modifyBoundEvents(eventAction) {
    this.container[eventAction]('focusout', this.focusOut, true);
    this.container[eventAction]('keydown', this.modalClickEvent(this), true);
    this.bounceBound[eventAction]('focusin', this.focusIn, true);
    return this;
  }






  attachFocusListeners() {
    return this.modifyBoundEvents('addEventListener');
  }






  removeFocusListeners() {
    return this.modifyBoundEvents('removeEventListener');
  }







  addClickHandler(target) {
    target.addEventListener('click', (event) => {
      this.getFocusoutTarget(event).focus();
    });
    return target;
  }








  addBounds() {
    this.container.insertBefore(this.topBound, this.container.firstElementChild);
    this.container.appendChild(this.bottomBound);
    this.container.appendChild(this.bounceBound);

    return this;
  }








  removeItem(item, container = this.container) {
    if (item && container.contains(item)) {
      container.removeChild(item);
    }
    return this;
  }








  removeBounds() {
    const { topBound, bottomBound, bounceBound } = this;
    this.removeItem(topBound)
      .removeItem(bottomBound)
      .removeItem(bounceBound);
    return this;
  }







  attachTrap() {
    this.setClasslist();
    this.addBounds();
    this.attachFocusListeners();
    this.container.setAttribute('tabindex', -1);
    return this;
  }







  removeTrap(containerClass = utilName) {
    if (this.container) {
      this.container.classList.remove(containerClass);
      this.removeFocusListeners();
      this.removeBounds();
    }
    return this;
  }
}

const createFocusTrap = args => new FocusTrap(args);
createFocusTrap.EVENTS = EVENTS;
export default createFocusTrap;
